/** Public base for R2-hosted assets. Object keys live under `oss_upload/`, and
 *  admin stores only the path below that (e.g. `202508/07/xxx.png`). */
export const R2_PUBLIC_BASE = 'https://static.roibest.com/oss_upload/';

/** Public custom domain of the R2 bucket `storage` (account-level, SSL active).
 *  Admin-uploaded images (POST /api/upload) land under `smart-link/` and are
 *  stored in links.logo as full URLs built from this base. */
export const R2_STORAGE_PUBLIC_BASE = 'https://storage.download.network/';

/** Build a full logo URL from the stored relative path. '' stays '' so callers
 *  can fall back to a template default; already-absolute URLs pass through. */
export function logoUrl(relativePath: string | undefined | null): string {
  const p = (relativePath ?? '').trim();
  if (!p) return '';
  if (/^https?:\/\//i.test(p)) return p;
  return R2_PUBLIC_BASE + p.replace(/^\/+/, '');
}
